module.exports = __webpack_public_path__ + "static/img/enroll.49e175a1.png";